import { render, staticRenderFns } from "./SummaryForm.vue?vue&type=template&id=dc48de6e&"
import script from "./SummaryForm.vue?vue&type=script&lang=js&"
export * from "./SummaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports